import { useMemo, useState } from "react";
import {
  TransitTiming,
  stepTransit,
  transitNow,
  transitTimezone,
  validTransitTiming,
} from "../utils/transitOverlay";
export function useTransitTiming(chart: any) {
  const timezoneOffset = transitTimezone(chart);
  const chartKey = JSON.stringify([
    chart?._id || chart?.id || chart?.birthDetails,
    timezoneOffset,
  ]);
  const initial = useMemo(
    () => transitNow(timezoneOffset),
    [chartKey, timezoneOffset],
  );
  const [selection, setSelection] = useState<{
    chartKey: string;
    timing: TransitTiming;
  }>();
  const timing = selection?.chartKey === chartKey ? selection.timing : initial;
  const setTiming = (next: TransitTiming) => {
    if (validTransitTiming(next)) setSelection({ chartKey, timing: next });
  };
  const step = (unit: "day" | "month", amount: number) =>
    setSelection((current) => ({
      chartKey,
      timing: stepTransit(
        current?.chartKey === chartKey ? current.timing : initial,
        unit,
        amount,
      ),
    }));
  const reset = () => setTiming(transitNow(timezoneOffset));
  return { timing, setTiming, step, reset, timezoneOffset };
}
